import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryOverview from './components/CategoryOverview';
import FeaturedPlatforms from './components/FeaturedPlatforms';
import HotArticles from './components/HotArticles';
import WhyChooseUs from './components/WhyChooseUs';
import FAQSection from './components/FAQSection';

const homeSchema = {
  name: '免费看片平台推荐',
  url: 'https://readdy.ai',
  description: '想找免费看片的好去处？本页汇总2024年最全正版免费看片平台，涵盖电影、电视剧、纪录片、动漫等海量资源，无需付费即可享受高清画质，安全合规、无广告骚扰，助你随时随地轻松追剧看电影。',
  inLanguage: 'zh-CN',
  publisher: {
    '@type': 'Organization',
    name: '免费看片平台推荐',
    url: 'https://readdy.ai',
  },
};

const orgSchema = {
  name: '免费看片平台推荐',
  url: 'https://readdy.ai',
  description: '致力于为用户推荐安全合规的正版免费影视平台',
};

export default function HomePage() {
  return (
    <>
      <SEOHead
        title="免费看片平台推荐·正版高清资源汇总 | 2024最全免费追剧网站导航"
        description="想找免费看片的好去处？本页汇总2024年最全正版免费看片平台，涵盖电影、电视剧、纪录片、动漫等海量资源，无需付费即可享受高清画质，安全合规、无广告骚扰，助你随时随地轻松追剧看电影。"
        keywords="免费看片,免费看片网站推荐,免费看片平台,正版免费电影,免费高清电影在线观看,免费追剧网站,免费看片不用注册"
        canonicalUrl="https://readdy.ai"
      />
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="WebSite" data={homeSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryOverview />
        <FeaturedPlatforms />
        <HotArticles />
        <WhyChooseUs />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}